import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";

// Actions
import { parseFetchOptions } from "../../state/user/actions";

// Config
import { useAppInsights } from "../../utils/telemetry/AppInsights";
import { checkPinUrl } from "../../config/apiConfig";

// Components
import LoadingSection from "../LoadingSection";
import MainSection from "../MainSection";

// Pages
import { PinLockScreen, PinCreateScreen } from "../../containers";

const useStyles = makeStyles(theme => ({
  mainSection: {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  }
}));

const PinValidatorHandler = ({ children, userExists }) => {
  const [authorized, setAuthorized] = useState(false);
  const [data, setData] = useState(null);
  const { trackException } = useAppInsights();
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userExists) {
      dispatch(
        parseFetchOptions(options =>
          fetch(checkPinUrl, options)
            .then(res => res.json())
            .then(d => setData(d))
            .catch(() => trackException("Failed to check pin existence"))
        )
      );
    }
  }, [userExists]);

  if (!userExists) return children;

  if (!data) return <LoadingSection />;
  if (!authorized) {
    const handleAuthorize = () => setAuthorized(true);
    const Screen = data.pinExists ? PinLockScreen : PinCreateScreen;
    return (
      <MainSection noStatus className={classes.mainSection}>
        <Screen onAuthorize={handleAuthorize} />
      </MainSection>
    );
  }

  return children;
};

PinValidatorHandler.propTypes = {
  children: PropTypes.node.isRequired,
  userExists: PropTypes.bool.isRequired
};

export default PinValidatorHandler;
